import React, { useEffect, useMemo } from "react";
import { useConfig } from "../contexts";
import useMedia from "../hooks/useMedia";
import { Breakpoint } from "../enums/Breakpoints";
import { I18NNamespace } from "../enums/I18NV3";
import createI18NV3 from "../i18nV3/i18nV3";
import PageLoader from "../components/PageLoader";
import { I18nextProvider } from "react-i18next";

const withV3TranslationsProvider = <T extends React.FC<any>>(
  WrappedComponent: T
) => {
  return (props: any) => {
    const config = useConfig();
    const isMobile = useMedia(Breakpoint.MaxMobile);
    const i18nV3 = useMemo(() => {
      if (config) {
        const namespace = isMobile
          ? I18NNamespace.Mobile
          : I18NNamespace.General;
        return createI18NV3(config.defaultLang, namespace);
      }
    }, [config, isMobile]);

    // i18nv3
    useEffect(() => {
      if (!!config && !!i18nV3) {
        const namespace = isMobile
          ? I18NNamespace.Mobile
          : I18NNamespace.General;
        if (i18nV3 && !i18nV3.options.ns?.includes(namespace)) {
          i18nV3.loadNamespaces(namespace);
        }
      }
    }, [config, i18nV3, isMobile]);

    return (
      <>
        {!i18nV3 ? (
          <PageLoader />
        ) : (
          <I18nextProvider i18n={i18nV3}>
            <WrappedComponent {...props} />
          </I18nextProvider>
        )}
      </>
    );
  };
};

export default withV3TranslationsProvider;
